export default __webpack_public_path__ + "static/media/tg_icon.db77cedc.png";